/**
 * @module services/patient-quick-form
 * @description Opciones y payload del alta rápida de paciente
 *              (`components/patient/PatientQuickForm.vue`, UC-REG-130),
 *              extraídos del componente para poder testearlos sin montar el
 *              SFC (vue-jest no compila los templates de appointment/).
 */

/** @description Tipos de documento ofrecidos en el alta rápida. */
export const QUICK_FORM_DOC_TYPES = [
  { value: "dni", label: "DNI" },
  { value: "pas", label: "Pasaporte" },
  { value: "li", label: "LE/LC" },
];

/**
 * @description Géneros ofrecidos en el alta rápida. Los valores son los del
 *              enum de `User.gender` en el API (`m`/`f`/`x`), los mismos que
 *              usa el alta completa (`PatientDetail.vue`). UC-REG-268: antes
 *              se mandaba `male/female/other` y el API rechazaba el alta.
 */
export const QUICK_FORM_GENDERS = [
  { value: "m", label: "Masculino" },
  { value: "f", label: "Femenino" },
  { value: "x", label: "Otro" },
];

/**
 * @description Arma el body de `POST /patients` a partir del form rápido.
 *              Los opcionales vacíos no se mandan; el username lo deriva el
 *              backend (DNI por default + sufijo si hay clash).
 * @param {Object} patient - Estado del form
 * @returns {Object}
 */
export function buildQuickPatientPayload(patient) {
  return {
    firstName: patient.firstName.trim(),
    lastName: patient.lastName.trim(),
    governmentId: {
      type: patient.governmentId.type,
      number: patient.governmentId.number.trim(),
    },
    ...(patient.bornAt && { bornAt: patient.bornAt }),
    ...(patient.gender && { gender: patient.gender }),
    ...(patient.email && { email: patient.email.trim() }),
    ...(patient.phone && { phone: patient.phone.trim() }),
  };
}
